import React, { useCallback, useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import * as MpProductsApi from '../api/MpProducts';
import type { MpProduct } from '../api/MpProducts';

type Props = {
  article: string;
  isNew: boolean;
};

export const GoodsMpLinksBlock = ({ article, isNew }: Props) => {
  const [links, setLinks] = useState<MpProduct[]>([]);
  const [search, setSearch] = useState('');
  const [candidates, setCandidates] = useState<MpProduct[]>([]);
  const [error, setError] = useState('');
  const [pending, setPending] = useState(false);

  const reload = useCallback(async () => {
    if (isNew || !article) return;
    setPending(true);
    setError('');
    try {
      setLinks(await MpProductsApi.listForGoods(article));
    } catch (e: any) {
      setError(e?.message || String(e));
    } finally {
      setPending(false);
    }
  }, [article, isNew]);

  useEffect(() => {
    void reload();
  }, [reload]);

  if (isNew) {
    return (
      <p style={{ color: '#888' }}>
        Сохраните товар, затем привяжите карточки МП.
      </p>
    );
  }

  return (
    <div style={{ marginBottom: 16 }}>
      <Form.Label>Связи с МП (Ozon / WB)</Form.Label>
      <p style={{ fontSize: 13, color: '#666', marginBottom: 8 }}>
        Без связи товар не уйдёт в отправку остатков. Выбор только из каталога МП.
      </p>
      {error && <p style={{ color: 'crimson' }}>{error}</p>}
      {links.length === 0 && !pending && (
        <p style={{ color: '#a60' }}>Не связан — в send не пойдёт</p>
      )}
      {links.map((p) => (
        <div
          key={p.id}
          style={{
            display: 'flex',
            gap: 8,
            alignItems: 'center',
            marginBottom: 6,
            flexWrap: 'wrap',
          }}
        >
          <strong>{p.marketplace}</strong>
          <span>{p.seller_sku}</span>
          {p.barcode && <span>bc:{p.barcode}</span>}
          <span style={{ color: '#666' }}>{p.title}</span>
          <Button
            size="sm"
            variant="outline-danger"
            onClick={async () => {
              await MpProductsApi.unlink(p.id);
              await reload();
            }}
          >
            Отвязать
          </Button>
        </div>
      ))}
      <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
        <Form.Control
          style={{ maxWidth: 280 }}
          size="sm"
          placeholder="поиск в каталоге МП"
          value={search}
          onChange={async (e) => {
            const v = e.target.value;
            setSearch(v);
            if (v.trim().length < 2) {
              setCandidates([]);
              return;
            }
            const res = await MpProductsApi.list({
              linked: 'unlinked',
              search: v,
              limit: 20,
            });
            setCandidates(res.items);
          }}
        />
        <Button size="sm" variant="secondary" onClick={() => reload()}>
          Обновить
        </Button>
      </div>
      {candidates.map((c) => (
        <div key={c.id} style={{ marginTop: 4 }}>
          <Button
            size="sm"
            variant="outline-primary"
            onClick={async () => {
              await MpProductsApi.link(c.id, article);
              setSearch('');
              setCandidates([]);
              await reload();
            }}
          >
            Привязать {c.marketplace}: {c.seller_sku} {c.title || ''}
          </Button>
        </div>
      ))}
    </div>
  );
};
